import { render, staticRenderFns } from "./BtnDownload.vue?vue&type=template&id=432a55b4&"
import script from "./BtnDownload.vue?vue&type=script&setup=true&lang=js&"
export * from "./BtnDownload.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports